<wl-info-card
  [buttonLink]="button"
  [buttonType]="rendering?.fields?.ButtonType?.value"
  [class.mb-3]="rendering?.fields.AddMarginBottom?.value"
  [message]="rendering?.fields.Message"
  [rendering]="rendering"
  [title]="rendering?.fields.Title"
  [type]="rendering?.fields.Type?.value || 'info'"
  class="d-block"
></wl-info-card>
